import React from 'react';
import CardDetails from './CardDetails';
import styled from 'styled-components';
const StyledCardContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 13px;
  margin-right: 6px;
`;
export default function StatusCard(props) {
  const resultCardData = props.statuCardData;
  return /*#__PURE__*/React.createElement(StyledCardContainer, null, resultCardData?.length > 0 ? resultCardData.map((data, index) => Object.keys(data).length > 0 ? /*#__PURE__*/React.createElement(CardDetails, {
    key: index,
    header: data.header,
    title: data.title,
    riskScore: data.overallRiskScore || data.originRiskScore,
    backgroundColor: data.backgroundColor
  }) : null) : null);
}